module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_9"
  }, [_vm._v("Copyright © 2017 by Lisa Preziosi")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, distributed or transmitted in any form or by any means, including photocopying, recording, or other electronic or mechanical methods, without the prior written permission of the publisher, except in the case of brief quotations embodied in critical reviews and certain other noncommercial uses permitted by copyright law. For permission requests, write to the publisher, addressed “Attention: Permissions Coordinator,” at the address below.")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }, [_vm._v("Xist Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }, [_vm._v("PO Box 61593")]), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }, [_vm._v("Irvine, CA 92602")]), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }, [_vm._v("www.xistpublishing.com")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }, [_vm._v("Publisher’s Note: This is a work of fiction. Names, characters, places, and incidents are a product of the author’s imagination. Locales and public names are sometimes used for atmospheric purposes. Any resemblance to actual people, living or dead, or to businesses, companies, events, institutions, or locales is completely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }, [_vm._v("Ordering Information:")]), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }, [_vm._v("Quantity sales. Special discounts are available on quantity purchases by corporations, associations, and others. For details, contact the “Special Sales Department” at the address above.")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }, [_vm._v("The Ice Maiden’s Tale/ Lisa Preziosi -- 1st ed.")]), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }, [_vm._v("ISBN 978-1-5324-0231-9")]), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }, [_vm._v("eISBN: 978-1-5324-0232-6")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6070d35e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_002.vue
// module id = 63
// module chunks = 0